// ---------------------------------------------------------------------------
// Shared report labels
// ---------------------------------------------------------------------------

/**
 * Label rendered in place of a null group key, in both the live Perspective
 * grid and the Excel export. A null group-by value is a legitimate group whose
 * key is null — distinct from the grand total — so it must read as an ordinary
 * group value rather than be mistaken for the total.
 *
 * Hardcoded to match the existing hardcoded 'Разом' totals label in report.ts.
 */
export const NO_GROUP_LABEL = 'Без групи'
